<h2>Available Videos</h2>

<button (click)="openVideo('video1')">
  Watch Video 1
</button>